import React from "react";

interface ConversationStarterInputProps {
  starter: { id: string; suggestion: string };
  onUpdate: (id: string, suggestion: string) => void;
  onRemove: (id: string) => void;
  disabled?: boolean;
}

const ConversationStarterInput: React.FC<ConversationStarterInputProps> = ({
  starter,
  onUpdate,
  onRemove,
  disabled = false,
}) => {
  return (
    <div className="flex gap-2">
      <input
        type="text"
        value={starter.suggestion}
        onChange={(e) => onUpdate(starter.id, e.target.value)}
        disabled={disabled}
        placeholder="Enter conversation starter..."
        className="flex-1 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-primary"
      />
      <button
        type="button"
        onClick={() => onRemove(starter.id)}
        disabled={disabled}
        className="px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Remove
      </button>
    </div>
  );
};

export default ConversationStarterInput;
